import { ErrorMessage, Field, Formik } from "formik";
import React from "react";
import { Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { imageUrls } from "../constants/images";
import { Texterror } from "../constants/Texterror";
import "../../styles/auth.scss";
import { Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { PaymentLogin } from "../constants/Validation";
export const CartLogin = () => {
  const history = useHistory();
  const { isLoading } = useSelector((state) => state.auth);
  const handleLogin = (values) => {
    sessionStorage.setItem("payment_user_details", JSON.stringify(values));
    const orderId = JSON.parse(sessionStorage.getItem("orderId"));
    const queryString = new URLSearchParams(orderId).toString();
    history.push(`/share_payment?${queryString}`);
  };
  localStorage.removeItem("newPatient");
  return (
    <div className="login_ss">
      <Container className="p-3">
        <Row className="d-flex justify-content-center align-items-center h-100">
          <Col>
            <div className="open_form">
              <div className="main_box">
                <div className="p-5 card-body w-100 d-flex flex-column">
                  <Link to={`/`}>
                    <img
                      src={imageUrls.logo}
                      className="img-fluid"
                      alt="Phone"
                    />
                  </Link>
                  <div className="mini_kog">
                    <h2 className="fw-bold mb-2 text-center">
                      Fill your details
                    </h2>

                    <p className="mb-4 text-center">
                      Enter your email and mobile number to proceed
                    </p>

                    <Formik
                      initialValues={{
                        payee_name: "",
                        payee_email: "",
                        payee_phone: "",
                      }}
                      validationSchema={PaymentLogin}
                      onSubmit={(values, { resetForm }) => {
                        handleLogin(values);
                        resetForm();
                      }}
                    >
                      {({ touched, errors, handleSubmit }) => (
                        <Form onSubmit={handleSubmit}>
                          <div className="mb-3">
                            <Field
                              className={`form-control ${
                                touched.payee_name && errors.payee_name
                                  ? "is-invalid"
                                  : ""
                              }`}
                              name="payee_name"
                              placeholder="Username"
                              type="input"
                            />
                            <ErrorMessage
                              name="payee_name"
                              component={Texterror}
                            />
                          </div>
                          <div className="mb-3">
                            <Field
                              className={`form-control ${
                                touched.payee_email && errors.payee_email
                                  ? "is-invalid"
                                  : ""
                              }`}
                              name="payee_email"
                              placeholder="Email"
                              type="input"
                            />
                            <ErrorMessage
                              name="payee_email"
                              component={Texterror}
                            />
                          </div>

                          <div className="mb-3">
                            <Field
                              className={`form-control ${
                                touched.payee_phone && errors.payee_phone
                                  ? "is-invalid"
                                  : ""
                              }`}
                              placeholder="Phone"
                              name="payee_phone"
                              type="number"
                            />
                            <ErrorMessage
                              name="payee_phone"
                              component={Texterror}
                            />
                          </div>
                          <button type="submit" className="sign_btn  !w-full">
                            {isLoading ? <Spinner /> : "Save Details"}
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
              <div className="second_box">
                <img src={imageUrls.signin} alt="doctor" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
